import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

// Searchable, server-backed — for institution lists, subject lists (docs/01-PRODUCT-SPEC.md §3.2),
// served by GET /public/lookup/large-list/:fieldId (§1). Options are NOT in the field config:
// shipping thousands of institutions to a mobile browser is exactly what this type exists to avoid.
const configSchema = z.object({
  datasetKey: z.string().min(1).default("institutions"),
  placeholder: z.string().max(100).optional(),
  allowFreeText: z.boolean().default(false),
});

export const largeListField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "large_list",
  label: "Searchable list",
  category: "choice",
  icon: "Search",
  configSchema,
  // Membership is checked server-side against the dataset at submit — the registry cannot know the
  // valid values without a database, and this package runs in the browser too.
  valueSchema: (_config, isRequired) =>
    optionalUnlessRequired(z.string().trim().min(1, "This field is required"), isRequired),
  defaultConfig: { datasetKey: "institutions", allowFreeText: false },
  supportsProfileBinding: true,
  defaultSearchable: true,
  renderHints: { isServerBacked: true },
};
